<template>
  <div class="member-history-tab">
    <div class="text-right mb-[20px]">
      <span>
        <el-tooltip placement="left" :appendToBody="true">
          <div slot="content">
            <div class="w-[180px]">
              {{ $t('member.tab.memberHistory.personalDataNotice') }}
            </div>
          </div>
          <span class="material-icons" style="font-size: 16px; margin-left: 5px">
            help_outline
          </span>
        </el-tooltip>
        {{ $t('member.tab.memberHistory.uploadReminder') }}
      </span>
      <BaseElButton
        type="primary"
        class="font-medium text-normal"
        @click=";(showDialog = true), (dialogType = 'create')"
      >
        {{ $t('member.tab.memberHistory.addHistory') }}
      </BaseElButton>
    </div>

    <!-- ANCHOR template 服務歷程表格 -->
    <BaseTable v-loading="loading" :data="historyList">
      <EmptyBlock slot="empty" />
      <BaseElTableColumn prop="Images" :label="$t('member.tab.memberHistory.image')" width="150" align="center">
        <template slot-scope="scope">
          <img
            style="margin: auto;"
            width="90"
            :src="imgUrl(scope.row.Images[0] || null)"
            alt=""
          >
        </template>
      </BaseElTableColumn>
      <BaseElTableColumn
        prop="fileName"
        :label="$t('member.tab.memberHistory.fileName')"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.FileId ? scope.row.fileName : '' }}
        </template>
      </BaseElTableColumn>
      <BaseElTableColumn
        prop="memberNote"
        :label="$t('member.tab.memberHistory.memberDescription')"
        align="center"
        show-overflow-tooltip
      />
      <BaseElTableColumn
        prop="note"
        :label="$t('member.tab.memberHistory.shopNote')"
        align="center"
        show-overflow-tooltip
      />
      <BaseElTableColumn
        prop="createdAt"
        :label="$t('member.tab.memberHistory.createdAt')"
        width="120"
        align="center"
      >
        <template slot-scope="scope">
          {{ dateFormat(scope.row.createdAt) }}
        </template>
      </BaseElTableColumn>
      <BaseElTableColumn prop="showMember" :label="$t('member.tab.memberHistory.publicDisplay')" align="center">
        <template slot-scope="scope">
          <Tag
            disable-transitions
            :type="scope.row.showMember ? 'action' : 'info'"
          >
            {{ scope.row.showMember ? $t('member.tab.memberHistory.yes') : $t('member.tab.memberHistory.no') }}
          </Tag>
        </template>
      </BaseElTableColumn>
      <BaseElTableColumn fixed="right" :label="$t('member.common.action.text')" width="100" align="center">
        <template slot-scope="scope">
          <el-popover placement="top">
            <div v-if="selectRow" class="table-edit-btn-popover">
              <BaseElButton
                type="text"
                class="table-opt-edit"
                icon="el-icon-search"
                @click="
                  ;(showDialog = true),
                    syncFormData(scope.row),
                    (dialogType = 'info')
                "
              >
                {{ $t('member.tab.memberHistory.view') }}
              </BaseElButton>
              <BaseElButton
                type="text"
                class="table-opt-edit"
                icon="el-icon-edit-outline"
                @click="
                  ;(showDialog = true),
                    syncFormData(scope.row),
                    (dialogType = 'update')
                "
              >
                {{ $t('member.tab.memberHistory.edit') }}
              </BaseElButton>
              <BaseElButton
                type="text"
                class="table-opt-del"
                icon="el-icon-delete"
                @click="deleteDialog = true"
              >
                {{ $t('member.tab.memberHistory.delete') }}
              </BaseElButton>
            </div>
            <BaseElButton
              slot="reference"
              type="text"
              class="btn-type-edit-row"
              icon="el-icon-setting"
              @click="selectRow = scope.row"
            />
          </el-popover>
        </template>
      </BaseElTableColumn>
    </BaseTable>

    <Pagination
      :curPage.sync="tableOptions.page"
      :pageLimit="tableOptions.pageLimit"
      :total="historyCount"
      @pageChange="refresh"
    />

    <!-- ANCHOR template 新增歷程-->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="showDialog"
      :close-on-click-modal="false"
      width="610px"
      @close="resetForm"
    >
      <BaseElForm
        ref="form"
        v-loading="formLoading"
        :model="formData"
        :rules="formRules"
        label-position="top"
      >
        <BaseElFormItem :label="$t('member.tab.memberHistory.publicDisplay')" prop="showMember">
          <Tag
            v-if="showInput(['info'])"
            :type="formData.showMember ? 'action' : 'info'"
          >
            {{ formData.showMember ? $t('member.tab.memberHistory.yes') : $t('member.tab.memberHistory.no') }}
          </Tag>
          <BaseElSwitch
            v-if="showInput(['create', 'update'])"
            v-model="formData.showMember"
            active-color="#2BB8C1"
            inactive-color="#AEAEAE"
            :active-text="$t('member.tab.memberHistory.yes')"
            :inactive-text="$t('member.tab.memberHistory.no')"
          />
        </BaseElFormItem>

        <BaseElFormItem :label="$t('member.tab.memberHistory.image')" prop="Images">
          <div class="flex gap-10">
            <div
              v-for="(img, index) in formData.Images"
              :key="img.id"
              class="img-wrapper"
            >
              <i
                v-if="showInput(['create', 'update'])"
                class="el-icon-circle-close remove-btn"
                @click="removeImg(index)"
              />

              <viewer
                v-if="showInput(['info'])"
                :images="[imgUrl(img)]"
                :options="viewerOptions"
              >
                <img :src="resizeImg(img, 1000)" style="cursor: pointer;">
              </viewer>

              <img
                v-if="showInput(['create', 'update'])"
                :src="imgUrl(img)"
                alt=""
              >
            </div>
            <UploadButton
              v-if="
                showInput(['create', 'update']) && formData.Images.length < 3
              "
              style="width: 90px; height: 90px;"
              :img="null"
              @change="imageChange"
            />
          </div>
        </BaseElFormItem>

        <BaseElFormItem
          v-if="formData.showMember"
          :label="$t('member.tab.memberHistory.memberDescription')"
          prop="memberNote"
        >
          <div v-if="showInput(['info'])" class="whitespace-pre-line">{{ formData.memberNote }}</div>
          <BaseElInput
            v-if="showInput(['create', 'update'])"
            v-model="formData.memberNote"
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 5 }"
            :placeholder="$t('member.tab.memberHistory.text')"
            maxlength="1000"
            show-word-limit
          />
        </BaseElFormItem>

        <BaseElFormItem :label="$t('member.tab.memberHistory.shopNote')" prop="note">
          <div v-if="showInput(['info'])" class="whitespace-pre-line">{{ formData.note }}</div>
          <BaseElInput
            v-if="showInput(['create', 'update'])"
            v-model="formData.note"
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 5 }"
            :placeholder="$t('member.tab.memberHistory.text')"
            maxlength="1000"
            show-word-limit
          />
        </BaseElFormItem>
        <div class="pt-2 pb-4">
          <hr class="">
        </div>
        <BaseElFormItem
          v-if="showInput(['create', 'update'])"
          :label="$t('member.tab.memberHistory.fileUpload')"
        >
          <InputFile
            :modelValue.sync="formData.file"
            accept="application/pdf"
            @errorFileType="$message.error($t('member.tab.memberHistory.fileFormatError'))"
            @errorFileSize="$message.error($t('member.tab.memberHistory.fileSizeExceeded'))"
            @update:modelValue="onUpdateFile"
            @removeFile="onRemoveFile"
          >
            <template v-slot:tip="{ size }">
              <div class="file-tips">
                <p class="mb-1">
                  {{ $t('member.tab.memberHistory.fileSizeHint', { size }) }}
                </p>
                <p>
                  {{ $t('member.tab.memberHistory.fileSecurityHint') }}
                </p>
              </div>
            </template>
          </InputFile>
        </BaseElFormItem>
        <BaseElFormItem :label="$t('member.tab.memberHistory.fileName')" prop="fileName">
          <div
            v-if="showInput(['info'])"
            class="underline text-primary-100 cursor-pointer"
            @click="onPreviewFile"
          >
            {{ formData.fileName }}
          </div>

          <BaseElInput
            v-if="showInput(['create', 'update'])"
            v-model="formData.fileName"
            maxlength="20"
            :placeholder="$t('member.tab.memberHistory.inputTextPlaceholder')"
            show-word-limit
          />
        </BaseElFormItem>
        <BaseElFormItem :label="$t('member.tab.memberHistory.fileDescription')" prop="fileDescription">
          <div v-if="showInput(['info'])">{{ formData.fileDescription }}</div>
          <BaseElInput
            v-if="showInput(['create', 'update'])"
            v-model="formData.fileDescription"
            class="input-file-desc"
            maxlength="50"
            :placeholder="$t('member.tab.memberHistory.inputTextPlaceholder')"
            show-word-limit
          />
        </BaseElFormItem>
      </BaseElForm>

      <div slot="footer">
        <BaseElButton
          v-if="showInput(['create', 'update'])"
          class="btn"
          plain
          @click=";(showDialog = false), (selectRow = null)"
        >
          {{ $t('member.tab.memberHistory.back') }}
        </BaseElButton>
        <BaseElButton
          class="btn"
          type="primary"
          :disabled="noContent"
          @click="handleConfirm"
        >
          {{ dialogBtn }}
        </BaseElButton>
      </div>
    </el-dialog>

    <ImageCropper
      v-if="uploadDialog"
      :image="image"
      :ratio="[2000, 2000]"
      @close="uploadDialog = false"
      @uploaded="getImage"
    />

    <DeleteDialog
      v-if="deleteDialog"
      :title="$t('member.tab.memberHistory.notice')"
      :content="$t('member.tab.memberHistory.deleteConfirmContent')"
      width="40%"
      @close="deleteDialog = false"
      @delete="deleteHistory(), refresh(), (deleteDialog = false)"
    />
    <WarningDialog
      v-if="warnDialog"
      :content="$t('member.tab.memberHistory.noFileWarning')"
      :cancelBtnString="$t('member.tab.memberHistory.continueEditing')"
      @close="onWarnDialog(false)"
      @confirm="onWarnDialog(true)"
    />
  </div>
</template>

<script>
import {
  CreateHistory,
  GetHistory,
  GetHistoryCount,
  FindHistory,
  UpdateHistory,
  DeleteHistory,
  GetHistoryFileSignedUrl,
} from '@/api/memberHistory'
import { imgSrc, extractList } from '@/utils/helper'
import EmptyBlock from '@/components/EmptyBlock.vue'
import ImageCropper from '@/components/ImageCropper.vue'
import UploadButton from '@/components/Button/UploadButton.vue'
import DeleteDialog from '@/components/Dialog/DeleteDialog'
import { pageStartIndex } from '@/utils/table'
import formUtils from '@/utils/form'
import { noEmptyRules, lengthRules } from '@/validation'
import MixinFunc from '@/components/MixinFunc.vue'
import InputFile from '@/components/Form/InputFile.vue'
import WarningDialog from '@/components/Dialog/WarningDialog.vue'
import { UploadFile } from '@/api/file'

import { ref } from 'vue'
import { useShop } from '@/use/shop'
export default {
  name: 'MemberHistoryTab',
  components: {
    DeleteDialog,
    ImageCropper,
    UploadButton,
    EmptyBlock,
    InputFile,
    WarningDialog,
  },
  mixins: [MixinFunc],
  props: ['member'],
  setup () {
    const { shopId } = useShop()
    const warnDialog = ref(false)
    const selectRow = ref(null)

    const waitDialog = ref(null)

    const onWarnDialog = (value) => {
      warnDialog.value = false
      if (waitDialog.value) {
        waitDialog.value(value)
        waitDialog.value = null
      }
    }

    const onPreviewFile = async (fileId) => {
      const [res, err] = await GetHistoryFileSignedUrl({
        shopId: shopId.value,
        id: selectRow.value.id,
      })
      if (err) {
        window.$message.error(err)
        return
      }
      window.open(res.url, '_blank')
    }
    return {
      warnDialog,
      waitDialog,
      onWarnDialog,
      onPreviewFile,
      selectRow,
    }
  },
  data: () => ({
    loading: false,
    formLoading: false,
    deleteDialog: false,
    showDialog: false,
    uploadDialog: false,
    dialogType: '',

    historyCount: 0,
    historyList: [],

    tableOptions: {
      page: 1,
      pageLimit: 10,
    },

    image: null,
    formData: {
      showMember: true,
      Images: [],
      memberNote: '',
      note: '',
      file: {},
      fileName: '',
      fileDescription: '',
    },
    fileId: '',
    viewerOptions: {
      toolbar: false,
      navbar: false,
      title: false,
    },
  }),
  computed: {
    shop () {
      return this.$store.getters.shop
    },

    startIndex () {
      return pageStartIndex(this.tableOptions.page, this.tableOptions.pageLimit)
    },

    imageIdList () {
      return extractList('id', this.formData.Images)
    },

    dialogTitle () {
      const type = this.dialogType
      let word = ''
      if (type === 'create') word = this.$t('member.tab.memberHistory.createTitle')
      if (type === 'update') word = this.$t('member.tab.memberHistory.editTitle')
      if (type === 'info') word = this.$t('member.tab.memberHistory.viewTitle')
      return word
    },

    dialogBtn () {
      const type = this.dialogType
      let word = ''
      if (type === 'create') word = this.$t('member.tab.memberHistory.createBtn')
      if (type === 'update') word = this.$t('member.tab.memberHistory.saveBtn')
      if (type === 'info') word = this.$t('member.tab.memberHistory.closeBtn')
      return word
    },

    noContent () {
      const form = this.formData
      let disable = false
      const noImgs = form.Images.length === 0
      const noMNote = form.memberNote === ''
      const noNote = form.note === ''
      const noFile = !form.file?.url && !form.file?.id //
      if (noImgs && noMNote && noNote && noFile) disable = true
      return disable
    },
    formRules () {
      const file = this.formData.file
      if (file.url) {
        return {
          fileName: [noEmptyRules(), lengthRules(0, 20)],
          fileDescription: [lengthRules(0, 50)],
          // images: [noEmptyRules()],
          // memberNote: [noEmptyRules()],
          // note: [noEmptyRules()],
        }
      }
      return {
        fileName: [lengthRules(0, 20)],
        fileDescription: [lengthRules(0, 50)],
      }
    },
  },

  async mounted () {
    await this.refresh()
  },

  methods: {
    async refresh () {
      this.loading = true
      await this.getHistory()
      await this.getHistoryCount()
      this.loading = false
    },
    showInput (arr) {
      return arr.includes(this.dialogType)
    },

    imageChange (img) {
      this.image = img

      this.uploadDialog = true
    },

    getImage (img) {
      this.formData.Images.push(img)
      this.image = img
      this.uploadDialog = false
    },

    imgUrl (img) {
      return imgSrc(300, img)
    },

    resizeImg (img, size) {
      return imgSrc(size, img)
    },

    removeImg (index) {
      this.formData.Images.splice(index, 1)
    },

    syncFormData (data) {
      const _data = JSON.parse(JSON.stringify(data))
      if (_data.FileId && _data.fileName) {
        _data.file = {
          filename: _data.fileName,
          id: _data.FileId,
        }
      } else {
        _data.file = {}
      }
      _data.fileName = _data.fileName || ''
      _data.fileDescription = _data.fileDescription || ''
      this.formData = _data
      this.fileId = ''
    },

    resetForm () {
      formUtils.resetForm(this.$refs.form)
      this.formData = {
        showMember: true,
        Images: [],
        memberNote: '',
        note: '',
        file: {},
        fileName: '',
        fileDescription: '',
      }
      this.fileId = ''
    },
    onUpdateFile (value) {
      const defaulFileName = value.raw?.name
      if (defaulFileName && !this.formData.fileName) {
        this.formData.fileName = defaulFileName
      }
    },
    onRemoveFile () {
      this.formData.fileName = ''
    },
    // ANCHOR 送出服務歷程
    async handleConfirm () {
      const type = this.dialogType

      // eslint-disable-next-line no-useless-return
      if (!(await formUtils.checkForm(this.$refs.form))) return

      this.formLoading = true
      const { file, fileName, fileDescription } = this.formData
      const res = await this.uploadFile({ ...file, name: fileName })

      if (!res) {
        this.formLoading = false
        return
      }
      this.fileId = res.id
      if ((fileName || fileDescription) && !this.fileId) {
        this.warnDialog = true
        const resWarn = await new Promise(resolve => {
          this.waitDialog = resolve
        })
        if (!resWarn) {
          this.formLoading = false
          return
        }
      }
      if (type === 'create') await this.createHistory()
      if (type === 'update') await this.updateHistory()
      this.showDialog = false
      this.resetForm()
      this.formLoading = false
    },

    async createHistory () {
      try {
        const form = this.formData
        await CreateHistory({
          shopId: this.shop,
          member: this.member.id,
          showMember: form.showMember,
          images: this.imageIdList,
          memberNote: form.showMember ? form.memberNote : undefined,
          note: form.note,
          file: this.fileId || null,
          fileName: form.fileName || undefined,
          fileDescription: form.fileDescription || undefined,
        })
        await this.refresh()
        this.$message.success(this.$t('member.tab.memberHistory.createSuccess'))
      } catch (error) {
        console.log(error)
        this.$message.error(error || error.message)
      }
    },

    async getHistory () {
      try {
        const res = await GetHistory({
          shopId: this.shop,
          start: this.startIndex,
          limit: this.tableOptions.pageLimit,
          MemberId: this.member.id,
        })

        this.historyList = res
      } catch (error) {
        console.log(error)
        this.$message.error(error || error.message)
      }
    },

    async getHistoryCount () {
      try {
        const res = await GetHistoryCount({
          shopId: this.shop,
          MemberId: this.member.id,
        })
        this.historyCount = res
      } catch (error) {
        console.log(error)
        this.$message.error(error || error.message)
      }
    },

    async findHistory () {
      try {
        const res = await FindHistory({
          shopId: this.shop,
          id: this.selectRow.id,
        })
        this.formData = res
      } catch (error) {
        console.log(error)
        this.$message.error(error || error.message)
      }
    },

    async updateHistory () {
      try {
        if (!(await formUtils.checkForm(this.$refs.form))) return
        const form = this.formData
        await UpdateHistory({
          shopId: this.shop,
          id: this.selectRow.id,
          showMember: form.showMember,
          images: this.imageIdList,
          memberNote: form.showMember ? form.memberNote : undefined,
          note: form.note,
          file: this.fileId || null,
          fileName: form.fileName || undefined,
          fileDescription: form.fileDescription || undefined,
        })
        await this.refresh()
        this.$message.success(this.$t('member.tab.memberHistory.updateSuccess'))
      } catch (error) {
        console.log(error)
        this.$message.error(error || error.message)
      }
    },

    async deleteHistory () {
      try {
        await DeleteHistory({
          shopId: this.shop,
          id: this.selectRow.id,
        })
        await this.refresh()
        this.$message.success(this.$t('member.tab.memberHistory.deleteSuccess'))
      } catch (error) {
        console.log(error)
        this.$message.error(error || error.message)
      }
    },
    // ANCHOR 上傳服務歷程檔案
    async uploadFile (payload) {
      const { raw, name } = payload
      try {
        let res, err
        if (raw) {
          [res, err] = await UploadFile({
            name,
            type: 'memberHistory',
            file: raw,
          })
        } else {
          return payload
        }
        if (err) {
          this.$message.error(err)
          return false
        }
        return res
      } catch (error) {
        console.log(error)
        this.$message.error(error || error.message)
        return false
      }
    },
  },
}
</script>

<style scoped lang="scss">
.img-wrapper {
  position: relative;
  width: 90px;
  border-radius: 4px;

  img {
    border-radius: 4px;
  }
}

.btn {
  width: 140px;
}

.remove-btn {
  border-radius: 4px;
  color: white;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.3);
}

.file-tips {
  line-height: 1.5;
  @apply text-gray-80;
}
// ::v-deep .el-dialog {
//   min-width: 650px !important;
// }

::v-deep .input-file-desc .el-input__inner {
  @apply pr-[48px];
}
</style>
